import React, { PureComponent, Suspense } from "react";
import { Card, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
// import ProfileTimeLine from "./ProfileTimeLine";
// import ProfileAuditLog from "./ProfileAuditLog";
import ProfileSubscriptions from "./ProfileSubscriptions";
import ProfileProducts from "./ProfileProducts";
import ProfileTransactions from "./ProfileTransactions";
import ProfileSettings from "./ProfileSettings";
import ProfileTeam from "./ProfileTeam";
import client from "../../../../../../shared/api-client";
import store from "../../../../redux/store/index";
import * as websites from "../../../../../../shared/service/websites";
import * as users from "../../../../../../shared/service/users";
const ProfileTimeLine = React.lazy(() => import("./ProfileTimeLine"));
const ProfileAuditLog = React.lazy(() => import("./ProfileAuditLog"));

export default class ProfileTabs extends PureComponent {
  state = {
    activeTab: "Profile",
    user: [],
    lead_scores: [],
    lead_stages: [],
    onboarding_status: [],
    userTypes: [],
    utmSources: [],
    productUseCases: [],
    domainsUsedIn: [],
    websites: [],
  };

  componentDidMount() {
    this.toggle = this.toggle.bind(this);

    this.getLeadScores();
    this.getOnBoardingStatuses();
    this.getLeadStages();
    this.getSources();
    this.getUtm();
    this.getProductUseCase();
    this.getDomainsUsedIn();
    this.getWebsites();
    this.getUserTypes();
    this.getBusinessSizes();
    this.getIndustry();
    this.getRole();
  }

  getWebsites = () => {
    websites.get().then((response) => {
      this.setState({ websites: response.data });
    });
  };

  getSources = () => {
    let sources = [];

    store.getState().usersFilters.sources.forEach((source) => {
      sources.push({
        value: source.key,
        label: source.name,
      });
    });

    this.setState({ sources });
  };

  getLeadScores = () => {
    users.getLeadScores().then((leadScores) => {
      let lead_scores = [];

      leadScores.forEach((leadScore) => {
        lead_scores.push({
          value: leadScore.lead_score,
          label: leadScore.lead_score,
        });
      });

      this.setState({ lead_scores });
    });
  };

  getBusinessSizes = () => {
    users.getBusinessSizes().then((businessSizes) => {
      this.setState({ businessSizes });
    });
  };

  getIndustry = () => {
    users.getIndustry().then((industry) => {
      this.setState({ industry });
    });
  };

  getRole = () => {
    users.getRole().then((role) => {
      this.setState({ role });
    });
  };

  getUserTypes = () => {
    users.getUserTypes().then((userTypes) => {
      this.setState({ userTypes });
    });
  };

  getLeadStages = () => {
    users.getLeadStages().then((lead_stages) => {
      this.setState({ lead_stages });
    });
  };

  getOnBoardingStatuses = () => {
    users.getOnBoardingStatuses().then((onboarding_status) => {
      this.setState({ onboarding_status });
    });
  };

  getUtm = () => {
    client(`utm.php`).then(
      (utm) => {
        let utmSources = [];

        utm.forEach((obj) => {
          utmSources.push({
            value: obj.utm,
            label: obj.utm,
          });
        });

        this.setState({ utmSources });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  getProductUseCase = () => {
    client(`productUseCase.php`).then(
      (productUseCase) => {
        let productUseCases = [];

        productUseCase.forEach((obj) => {
          productUseCases.push({
            value: obj.value,
            label: obj.value,
          });
        });

        this.setState({ productUseCases });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  getDomainsUsedIn = () => {
    client(`domainsUsedIn.php`).then(
      (response) => {
        let domainsUsedIn = [];

        response.forEach((obj) => {
          domainsUsedIn.push({
            value: obj.value,
            label: obj.value,
          });
        });

        this.setState({ domainsUsedIn });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  handleForm = (user) => {
    this.setState(user, () => {
      //console.log(user);
    });
  };

  render() {
    return (
      <Card>
        <div className="profile__card tabs tabs--justify tabs--bordered-bottom">
          <div className="tabs__wrap">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "Profile",
                  })}
                  onClick={() => {
                    this.toggle("Profile");
                  }}
                >
                  Profile
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "Qualification",
                  })}
                  onClick={() => {
                    this.toggle("Qualification");
                  }}
                >
                  Qualification
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "Products",
                  })}
                  onClick={() => {
                    this.toggle("Products");
                  }}
                >
                  Products
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "2",
                  })}
                  onClick={() => {
                    this.toggle("2");
                  }}
                >
                  Audit Log
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "Userteam",
                  })}
                  onClick={() => {
                    this.toggle("Userteam");
                  }}
                >
                  Team
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "4",
                  })}
                  onClick={() => {
                    this.toggle("4");
                  }}
                >
                  Transactions
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "Settings",
                  })}
                  onClick={() => {
                    this.toggle("Settings");
                  }}
                >
                  Settings
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "Notes",
                  })}
                  onClick={() => {
                    this.toggle("Notes");
                  }}
                >
                  Notes
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <Suspense fallback={<div>Loading...</div>}>
                  <ProfileTimeLine id={this.props.id} />
                </Suspense>
              </TabPane>
              <TabPane tabId="2">
                {this.state.activeTab == 2 ? (
                  <Suspense fallback={<div>Loading...</div>}>
                    <ProfileAuditLog id={this.props.id} />
                  </Suspense>
                ) : (
                  ""
                )}
              </TabPane>
              <TabPane tabId="Products">
                {this.state.activeTab == "Products" ? (
                  <ProfileProducts
                    id={this.props.id}
                    websites={this.state.websites}
                  />
                ) : (
                  ""
                )}
              </TabPane>
              <TabPane tabId="3">
                {this.state.activeTab == 3 ? (
                  <ProfileSubscriptions id={this.props.id} />
                ) : (
                  ""
                )}
                <ProfileSubscriptions id={this.props.id} />
              </TabPane>
              <TabPane tabId="4">
                {this.state.activeTab == 4 ? (
                  <ProfileTransactions id={this.props.id} />
                ) : (
                  ""
                )}
              </TabPane>
              <TabPane tabId="Userteam">
                {this.state.activeTab == "Userteam" ? (
                  <ProfileTeam id={this.props.id} />
                ) : (
                  ""
                )}
              </TabPane>
              <TabPane tabId="Settings">
                {this.state.activeTab == "Settings" ? (
                  <ProfileSettings
                    onSubmit={this.updateUserSettingsState}
                    id={this.props.id}
                    user={this.state.user}
                    leadScores={this.state.lead_scores}
                    leadStages={this.state.lead_stages}
                    onBoardingStatus={this.state.onboarding_status}
                    sources={this.state.sources}
                    utmSources={this.state.utmSources}
                    userTypes={this.state.userTypes}
                    handleForm={this.handleForm}
                    businessSizes={this.state.businessSizes}
                    industry={this.state.industry}
                    role={this.state.role}
                    domainsUsedIn={this.state.domainsUsedIn}
                    productUseCases={this.state.productUseCases}
                    tab="Access Settings"
                  />
                ) : (
                  ""
                )}
              </TabPane>
              <TabPane tabId="Profile">
                {this.state.activeTab == "Profile" ? (
                  <ProfileSettings
                    onSubmit={this.updateUserSettingsState}
                    id={this.props.id}
                    user={this.state.user}
                    leadScores={this.state.lead_scores}
                    leadStages={this.state.lead_stages}
                    onBoardingStatus={this.state.onboarding_status}
                    sources={this.state.sources}
                    utmSources={this.state.utmSources}
                    userTypes={this.state.userTypes}
                    handleForm={this.handleForm}
                    businessSizes={this.state.businessSizes}
                    industry={this.state.industry}
                    role={this.state.role}
                    domainsUsedIn={this.state.domainsUsedIn}
                    productUseCases={this.state.productUseCases}
                    tab="Profile"
                  />
                ) : (
                  ""
                )}
              </TabPane>

              <TabPane tabId="Notes">
                {this.state.activeTab == "Notes" ? (
                  <ProfileSettings
                    onSubmit={this.updateUserSettingsState}
                    id={this.props.id}
                    user={this.state.user}
                    leadScores={this.state.lead_scores}
                    leadStages={this.state.lead_stages}
                    onBoardingStatus={this.state.onboarding_status}
                    sources={this.state.sources}
                    utmSources={this.state.utmSources}
                    userTypes={this.state.userTypes}
                    handleForm={this.handleForm}
                    businessSizes={this.state.businessSizes}
                    industry={this.state.industry}
                    role={this.state.role}
                    domainsUsedIn={this.state.domainsUsedIn}
                    productUseCases={this.state.productUseCases}
                    tab="Notes"
                  />
                ) : (
                  ""
                )}
              </TabPane>
              <TabPane tabId="Qualification">
                {this.state.activeTab == "Qualification" ? (
                  <ProfileSettings
                    onSubmit={this.updateUserSettingsState}
                    id={this.props.id}
                    user={this.state.user}
                    leadScores={this.state.lead_scores}
                    leadStages={this.state.lead_stages}
                    onBoardingStatus={this.state.onboarding_status}
                    sources={this.state.sources}
                    utmSources={this.state.utmSources}
                    userTypes={this.state.userTypes}
                    handleForm={this.handleForm}
                    businessSizes={this.state.businessSizes}
                    industry={this.state.industry}
                    role={this.state.role}
                    domainsUsedIn={this.state.domainsUsedIn}
                    productUseCases={this.state.productUseCases}
                    tab="Settings"
                  />
                ) : (
                  ""
                )}
              </TabPane>
            </TabContent>
          </div>
        </div>
      </Card>
    );
  }
}
